// in src/users.js
import React from 'react';
import {List, Datagrid, TextField, ImageField, ArrayField, SingleFieldList, ChipField, DateField, FunctionField, Pagination} from 'react-admin';
import {ColumnsFilters} from './ColumnsFilter';
import {COLUMN} from '../../consts/Names';
import { areYouStrangeString } from '../utils/TextChecker';


export const СolumnList = (props) => {
   return (
      <List {...props} filters={<ColumnsFilters />} sort={{field: COLUMN.created_at, order: 'ASC'}} bulkActionButtons={false} exporter={false} title="Articles"  perPage={25} pagination={<Pagination rowsPerPageOptions={[25,50,100,200]}/>}>
         <Datagrid rowClick="edit">
            <TextField source={COLUMN.id} sortable={false} />
             <FunctionField source={COLUMN.title} sortable={false} render={record => areYouStrangeString(record,'title', false)}/>
            <DateField source={COLUMN.created_at} label="Date of creation" />
            <ImageField source={COLUMN.thumbnail_image} sortable={false} />
            <ArrayField label="Categories" source={COLUMN.categories} sortable={false}>
               <SingleFieldList linkType={false}>
                  <ChipField source="name" />
               </SingleFieldList>
            </ArrayField>
         </Datagrid>
      </List>
   );
};
